<div class="hw-box-content">
    <div class="hw-header-wrap">
        <div class="row">
            <div class="col-6">
                <i class="fn-global-site"></i>
                Status Type
            </div>
            <div class="col-6 text-right">
                <fn-button *ngIf="!showData" [type]="'primary'" [btnClass]="'btn btn-sm btn-round'" [text]="'Add'"
                    (click)="openActionMdl()"></fn-button>
            </div>
        </div>
    </div>
    <div class="hw-content">
        <div class="row">
            <div class="col-12" *ngIf="!showData">
                @if (uiMap.isDataLoaded) {
                <fn-table [config]='config' [rowMetaArray]='rowMetaArray' [dataArray]='statusTypeArray' [pageSize]="15"
                    (updateRow)="updateRowAction($event)" (deleteRow)="deleteRowAction($event)"></fn-table>
                }
            </div>
            <div class="col-12" *ngIf="showData">
                <h5 class="font-14 d-none ">Add or update actions</h5>
                <div class="form-group flex-container">
                    <div class="form-item">
                        <label for="idenNo">idenNo</label>
                        <fn-base-input placeholder="Enter idenNo" [(ngModel)]="objectHash.idenNo"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>
                    <div class="form-item">
                        <label for="uniqueKey">uniqueKey</label>
                        <fn-base-input placeholder="Enter uniqueKey" [(ngModel)]="objectHash.uniqueKey"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>

                    <div class="form-item">
                        <label for="severity">Severity</label>
                        <fn-select [labelKey]="'name'" [inputKey]="'name'" [optionList]="sevArray"
                            [placeholder]="'Severity'" [(ngModel)]="objectHash.severity"
                            [ngModelOptions]="{standalone: true}">
                        </fn-select>
                    </div>
                    <div class="form-item">
                        <label for="cause">cause</label>
                        <fn-base-input placeholder="Enter cause" [(ngModel)]="objectHash.cause"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>
                </div>
                <div class="form-group flex-container">
                    <div class="form-item">
                        <label for="eoProduct">Product</label>
                        <fn-select [labelKey]="'name'" [inputKey]="'primaryKey'" [optionList]="productArray"
                            [placeholder]="'Select product'" [(ngModel)]="objectHash.eoProduct"
                            [ngModelOptions]="{standalone: true}">
                        </fn-select>
                    </div>
                    <div class="form-item">
                        <label for="teams" class="form-label">Teams</label>
                        <fn-multi-select [labelKey]="'name'" [inputKey]="'primaryKey'" [optionList]="teamsArray"
                            [placeholder]="'Select Teams'" [(ngModel)]="objectHash.teams"></fn-multi-select>
                    </div>
                    <div class="form-item">
                        <label for="defaultEscEmailID">
                            Default Esc EmailID</label>
                        <fn-base-input placeholder="Enter Default email" [(ngModel)]="objectHash.defaultEscEmailID"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>
                    <div class="form-item">
                        <label for="typeIID">typeIID</label>
                        <fn-select [labelKey]="'name'" [inputKey]="'name'" [optionList]="typeIIDArray"
                            [placeholder]="'Reset TypeID'" [(ngModel)]="objectHash.typeIID"
                            [ngModelOptions]="{standalone: true}">
                        </fn-select>
                    </div>

                </div>
                <div class="form-group flex-container">
                    <div class="form-item">
                        <label for="isActive">isActive</label>
                        <fn-switch [(ngModel)]="objectHash.isActive" [name]="'isPictureRequired'"></fn-switch>
                    </div>
                    <div class="form-item">
                        <label for="isAutoEscalate">isAutoEscalate</label>
                        <fn-switch [(ngModel)]="objectHash.isAutoEscalate" [name]="'isPictureRequired'"></fn-switch>
                    </div>
                    <div class="form-item">
                        <label for="isSendMail">isSendMail</label>
                        <fn-switch [(ngModel)]="objectHash.isSendMail" [name]="'isPictureRequired'"></fn-switch>
                    </div>
                    <div class="form-item">
                        <label for="isSendToTeligram">isSendToTelegram</label>
                        <fn-switch [(ngModel)]="objectHash.isSendToTeligram" [name]="'isPictureRequired'"></fn-switch>
                    </div>

                </div>
                <div class="form-group flex-container">
                    <div class="form-item">
                        <label>Telegram Message ID (Current Sev)</label>
                        <fn-base-input type="TEXT" placeholder="Telegram Message ID"
                            [(ngModel)]="objectHash.telMeassageId"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>
                    <div class="form-item">
                        <label>Telegram Message ID (Upgraded Sev)</label>
                        <fn-base-input type="TEXT" placeholder="Telegram Message ID"
                            [(ngModel)]="objectHash.sevTelMessageId"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>

                    <div class="form-item">
                        <div class="form-container"></div>
                        <label for="canDisable">canDisable</label>
                        <fn-switch [(ngModel)]="objectHash.canDisable" [name]="'isPictureRequired'"></fn-switch>
                    </div>
                    <div class="form-item">
                        <label for="isManualResolvable">isManualResolvable</label>
                        <fn-switch [(ngModel)]="objectHash.isManualResolvable" [name]="'isPictureRequired'"></fn-switch>
                    </div>
                </div>
                <div class="form-group flex-container">

                    <div class="form-item">
                        <label for="countForCriticality">
                            {{ objectHash.isDualConditional ? 'SevChangeAlertCounter' : 'AlertCountForSevChange' }}
                        </label>
                        <fn-base-input placeholder="Enter countForCriticality"
                            [(ngModel)]="objectHash.countForCriticality"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>
                    <div class="form-item">
                        <label for="isCountBreach">updateSevrityonValue</label>
                        <fn-switch [(ngModel)]="objectHash.isCountBreach" [name]="'isPictureRequired'"
                            (ngModelChange)="!$event && (objectHash.isDualConditional = false)">
                        </fn-switch>
                    </div>
                    <div class="form-item" [style.visibility]="objectHash.isCountBreach ? 'visible' : 'hidden'">
                        <label for="breachCount">AlertValueforSevChange</label>
                        <fn-base-input placeholder="Enter breachCount" [(ngModel)]="objectHash.breachCount"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>
                    <div class="form-item" [style.visibility]="objectHash.isCountBreach ? 'visible' : 'hidden'">
                        <label for="isDualConditional">UseEscalationCount</label>
                        <fn-switch [(ngModel)]="objectHash.isDualConditional" [name]="'isPictureRequired'"></fn-switch>
                    </div>
                </div>
                <div class="form-group flex-container">
                    <div class="form-item">
                        <label for="resolution">resolution</label>
                        <fn-base-input placeholder="Enter resolution" [(ngModel)]="objectHash.resolution"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>
                    <div class="form-item">
                        <label for="escEmailSub">escEmailSub</label>
                        <fn-base-input placeholder="Enter escEmailSub" [(ngModel)]="objectHash.escEmailSub"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>

                    <div class="form-item">
                        <label for="resetOffsetTimeInMin">resetOffsetTimeInMin</label>
                        <fn-base-input placeholder="Enter resetOffsetTimeInMin"
                            [(ngModel)]="objectHash.resetOffsetTimeInMin"
                            [ngModelOptions]="{standalone: true}"></fn-base-input>
                    </div>
                </div>
                <div class="form-group">
                    <fn-button type="success" btnClass="btn-sm" text="Submit" (click)="add()"></fn-button>
                    <fn-button type="danger" btnClass="btn-sm" text="Close" (click)="close()"></fn-button>
                </div>
            </div>
        </div>
    </div>
</div>